var map = {
	"./0.png": 26148,
	"./1.png": 80045,
	"./2.png": 49718,
	"./3.png": 63007,
	"./4.png": 11680,
	"./5.png": 89801,
	"./6.png": 75186,
	"./slot_frame.png": 92120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41053;